import React from 'react';
import { Button } from '../../test/components/ui';
import { AnimatedClasses } from '../../utils/animatedStyles';
import { useCloseModal } from './hooks/useCloseModal';
import * as Styles from './styles';
import config from '../../utils/config';

interface Props {
  closeHandler: () => void;
  changeHandler: () => void;
}

export const ChangeFio: React.FC<Props> = ({ closeHandler, changeHandler }) => {
  const { refInnWrapper, closeModal } = useCloseModal(closeHandler);

  return (
    <Styles.ModalOuterWrapperS>
      <Styles.ModalInnerWrapperS style={{ maxWidth: '600px' }} ref={refInnWrapper} className={AnimatedClasses.zoomIn}>
        <div style={{ padding: '5px', textAlign: 'right' }}>
          <i style={{ cursor: 'pointer', fontSize: '25px' }} className="bi bi-x" onClick={closeModal} />
        </div>
        <Styles.ModalBodyS>
          Якщо ім’я вказано невірно, зробіть <strong>одноразове</strong> виправлення особистих даних в розділі «Про мене» та сформуйте вірний
          сертифікат. Більше одного виправлення не допускається
        </Styles.ModalBodyS>
        <Styles.ModalFooterS style={{ textAlign: 'right' }}>
          <Button
            onClick={() => {
              window.open(`${config.URL_ID3_CABINET}/profile`);
              changeHandler();
            }}
            title="Змінити"
          />
        </Styles.ModalFooterS>
      </Styles.ModalInnerWrapperS>
    </Styles.ModalOuterWrapperS>
  );
};
